import { LoadingButton } from "@mui/lab";
import { InputAdornment, OutlinedInput } from "@mui/material";
import { t } from "i18next";
import { ChangeEvent, Dispatch, SetStateAction } from "react";

interface Props {
  setTextInputValue: Dispatch<SetStateAction<string>>;
  textInputValue: string;
  isLoading: boolean;
}

const TextInputEmail = ({
  setTextInputValue,
  textInputValue,
  isLoading,
}: Props) => {
  const handleOnChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setTextInputValue(event.target.value);
  };

  return (
    <OutlinedInput
      type={"email"}
      placeholder={t("hero.email.text-input.placeholder")}
      value={textInputValue}
      onChange={handleOnChange}
      endAdornment={
        <InputAdornment position={"end"}>
          <LoadingButton
            type={"submit"}
            variant={"contained"}
            disabled={!textInputValue.length}
            loading={isLoading}
          >
            {t("hero.email.text-input.button.label")}
          </LoadingButton>
        </InputAdornment>
      }
    />
  );
};

export default TextInputEmail;
